module.exports = __webpack_public_path__ + "static/media/AF.d87908ff.svg";